import { apiClient } from "../client";
import { API_ENDPOINTS } from "../endpoints";
import { getRefreshToken } from "@/utils/storage";

export const authService = {
  login: (data: { email: string; password: string }) =>
    apiClient.post(API_ENDPOINTS.AUTH.LOGIN, data),

  refresh: () => {
    const refreshToken = getRefreshToken();
    return apiClient.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });
  },

  logout: () => {
    const refreshToken = getRefreshToken();
    return apiClient.post(API_ENDPOINTS.AUTH.LOGOUT, { refreshToken }).catch(() => {});
  },
};
